import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ErrorNotifier } from "src/components/common/error-notifier";
import { ApolloProvider } from "src/graphql/client/apollo-provider";
import "./index.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { loadNewRelic } from "./newrelic";

loadNewRelic();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ErrorNotifier>
      {({ addError }) => (
        <ApolloProvider addError={addError}>
          <App />
        </ApolloProvider>
      )}
    </ErrorNotifier>
  </React.StrictMode>,
);
